export default Object.freeze({
  L: 'E',
  R: 'D',
});
